/* Svensk katalog for locale-sales-payments-customers-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'inv.unknownAccount': 'Okänt konto',
  'inv.refund.customerBalance': "Tillgodo hos oss",
  'inv.refund.balanceHelp': "Saldot inkluderar kreditnotorna och inbetalningarna och återbetalningarna nedan.",
  'inv.refund.addFee': "Lägg till avgift",
  'inv.refund.businessFee': "Avgift betald av företaget",
  'inv.refund.customerReceives': "Kunden får",
  'inv.refund.accountDebit': "Totalt uttag från kontot",
  'sale.pay.ownerDebt': "Kortfristig skuld till ägare",
  'sale.pay.title': 'Betalning',
  'sale.pay.help': 'Välj vilket konto försäljningen betalades till och vilket datum. Lägg till avgift eller dela upp betalningen i flera inbetalningar. Totalen måste stämma med försäljningsraderna.',
  'sale.pay.paidTo': 'Betalt till',
  'sale.pay.choosePaymentAccount': 'Välj betalkonto',
  'sale.create.needPaymentAccount': 'Välj Betalt till innan du registrerar försäljningen.',
  'sale.pay.paidDate': 'Betaldatum',
  'sale.pay.fee': 'Avgift',
  'sale.pay.addFee': 'Lägg till avgift',
  'sale.pay.removeFee': 'Ta bort avgift',
  'sale.pay.partial': 'Delbetalningar',
  'sale.pay.addPartial': 'Lägg till delbetalning',
  'sale.pay.removePartial': 'Ta bort delbetalning',
  'sale.pay.seeTransaction': 'Se transaktion',
  'sale.pay.addAccount': 'Lägg till konto',
  'sale.pay.addCard': 'Lägg till kreditkort',
  'sale.pay.addBankTitle': 'Lägg till bankkonto',
  'sale.pay.addCardTitle': 'Lägg till kreditkort',
  'sale.pay.addSolutionTitle': 'Lägg till betallösning',
  'sale.pay.solution': 'Betallösning',
  'sale.pay.accountType': 'Kontotyp',
  'sale.pay.cardOwner': 'Kortet tillhör',
  'sale.pay.displayName': 'Visningsnamn (valfritt)',
  'sale.pay.orgNumber': 'Org.nummer',
  'sale.pay.openingBalance': 'Startsaldo för avstämning',
  'sale.pay.openingBalanceDate': 'Datum för startsaldo',
  'sale.pay.resetChoice': 'Återställ val',
  'sale.cust.helpTitle': 'Kund på försäljningen',
  'sale.cust.help': 'Här väljer du vem försäljningen gäller. Sök upp en sparad kund, lista eller prenumeration — eller tryck på ”Ny kund” för att ange en mottagare som inte är sparad sedan tidigare. Namn och adress hämtas automatiskt till dokumentet.',
  'sale.cust.optionalHelp': 'Kund är valfritt vid övrig försäljning. Slå på om du vill koppla försäljningen till en viss kund.',
  'sale.cust.search': 'Sök bland kunder, listor och prenumerationer...',
  'sale.cust.pickExisting': 'Välj befintlig',
  'sale.cust.new': 'Ny kund',
  'sale.cust.add': 'Lägg till kund',
  'sale.cust.selected': 'Vald kund',
  'sale.cust.selectedList': 'Vald mottagarlista',
  'sale.cust.none': 'Ingen kund vald ännu',
  'sale.cust.listsAndSubs': 'Listor och prenumerationer',
  'sale.cust.detailsTitle': 'Kunduppgifter',
  'sale.cust.name': 'Kundnamn',
  'sale.cust.namePh': 'T.ex. Exempel AS',
  'sale.cust.number': 'Kundnr',
  'sale.cust.org': 'Org.nr',
  'sale.cust.orgPh': '123 456 789',
  'sale.cust.address': 'Adress',
  'sale.cust.addressPh': 'Gatuadress, postnr och ort',
  'sale.cust.email': 'E-post',
  'sale.cust.emailPh': 'post@eksempel.no',
  'sale.cust.phone': 'Telefon',
  'sale.cust.phonePh': '400 00 000',
  'sale.cust.contacts': 'Kontaktpersoner',
  'sale.cust.noContacts': 'Inga kontaktpersoner tillagda.',
  'sale.cust.addContact': 'Lägg till kontaktperson',
  'sale.cust.removeContact': 'Ta bort kontaktperson',
  'sale.cust.contactName': 'Namn',
  'sale.cust.contactNamePh': 'T.ex. Kari Nordmann',
  'sale.cust.contactRole': 'Roll',
  'sale.cust.contactRolePh': 'T.ex. Ekonomi',
  'sale.cust.outstanding': 'Utestående',
  'sale.cust.revenueToDate': 'Omsättning hittills',
  'sale.cust.pickPh': 'Kund eller nummer',
  'sale.cust.select': 'Välj kund',
  'sale.cust.use': 'Använd kund',
  'sale.cust.noEmail': 'Ingen e-post på kunden',
  'sale.cust.listDefaultName': 'Kundlista',
  'sale.cust.updatedToast': 'Kund uppdaterad i försäljningen',
  'sale.cust.noCustomerHelp': 'Försäljningen registreras utan kund. Slå på reglaget om du vill koppla den till en kund.',
  'sale.cust.selectHint': 'Välj en sparad kund, lista eller prenumeration - eller använd Ny kund för fri inmatning.',
  'sale.cust.recipientsCount': '{count} mottagare',
  'sale.cust.kindSubscription': 'Prenumeration',
  'sale.cust.kindList': 'Lista',
  'sale.cust.noMatches': 'Inga träffar på ”{query}”.',
  'sale.cust.addAsNew': 'Lägg till ”{query}” som ny kund',
  'sale.cust.contactDefaultName': 'Kontaktperson {n}',
  'sale.cust.saveFailed': 'Kunde inte spara kunden.',
  'sale.pay.accountNameSavings': 'Sparkonto',
  'sale.pay.accountNameOperating': 'Företagskonto',
  'sale.pay.accountNamePrivate': 'Privatkonto',
  'sale.pay.accountNameBank': 'Bankkonto',
  'sale.pay.groupBank': 'Bankkonton',
  'sale.pay.groupCard': 'Kreditkort',
  'sale.pay.groupPrivate': 'Privat',
  'sale.pay.groupOther': 'Övrigt',
  'sale.pay.groupGeneric': 'Konton',
  'sale.pay.cashLabel': 'Kontant',
  'sale.pay.bankNameRequired': 'Ge bankkontot ett namn',
  'sale.pay.accountOrCardNameRequired': 'Ge kontot eller kortet ett namn',
  'sale.pay.accountNumberRequired': 'Fyll i kontonummer',
  'sale.pay.bankAccountAdded': 'Bankkonto tillagt',
  'sale.pay.privateAccountAdded': 'Privatkonto tillagt',
  'sale.pay.saveAccountFailed': 'Kunde inte spara kontot.',
  'sale.pay.accountsUnavailable': 'Betalkonton är inte kopplade till backend.',
  'sale.pay.openingSetupRequired': 'Fyll i startdatum och startsaldo. Skriv 0 om saldot var noll.',
  'sale.pay.invalidLedgerAccount': 'Giltigt kontonummer i kontoplanen saknas.',
  'sale.pay.accountExists': 'Konto {code} finns redan.',
  'sale.pay.typePrivateCard': 'Privatkonto / kort',
  'sale.pay.newBankAccountNote': 'Nytt bankkonto skapas i kontoplanen',
  'sale.pay.newPrivateAccountNote': 'Nytt privatkonto/kort skapas i kontoplanen',
  'sale.pay.bankAccountSeriesInfo': 'Bankkonton får nästa lediga konto i 192x-serien.',
  'sale.pay.privateAccountSeriesInfo': 'Privata kort/konton får nästa lediga avräkningskonto i 206x-serien.',
  'sale.pay.thisGetsAccount': 'Detta får konto',
  'sale.pay.accountNameLabel': 'Kontonamn',
  'sale.pay.accountOrCardNameLabel': 'Namn på konto / kort',
  'sale.pay.accountNamePhBank': 'T.ex. Företagskonto 2',
  'sale.pay.accountNamePhPrivate': 'T.ex. Ägarkort Visa',
  'sale.pay.accountNumberLabel': 'Kontonummer',
  'sale.pay.accountCardRefLabel': 'Konto / kortnummer / referens (valfritt)',
  'sale.pay.interimAccountPrefix': 'Avräkning',
  'sale.pay.cardNameRequired': 'Ge kreditkortet ett namn',
  'sale.pay.cardNumberRequired': 'Fyll i kort-/kontonummer',
  'sale.pay.openingBalanceRequired': 'Fyll i startsaldo och datum för startsaldo',
  'sale.pay.creditCardDebtPrefix': 'Kreditkortsskuld',
  'sale.pay.cardAdded': 'Kreditkort tillagt',
  'sale.pay.saveCardFailed': 'Kunde inte spara kreditkortet.',
  'sale.pay.scopeBusiness': 'Företag',
  'sale.pay.businessCardNote': 'Företagskort bokförs som egen kortskuld',
  'sale.pay.privateCardNote': 'Privat kort bokförs som avräkning',
  'sale.pay.businessCardSeriesInfo': 'Företagskort som inte är bankkonto får nästa lediga konto i 238x-serien.',
  'sale.pay.privateCardSeriesInfo': 'Privata kort får nästa lediga avräkningskonto i 206x-serien.',
  'sale.pay.accountInLedger': 'Konto i bokföringen:',
  'sale.pay.cardNamePhBusiness': 'T.ex. Företagskort Visa',
  'sale.pay.cardNamePhPrivate': 'T.ex. Ägarkort Mastercard',
  'sale.pay.cardNumberLabel': 'Kortnummer / kontonummer',
  'sale.pay.cardNumberLabelOptional': 'Kortnummer / kontonummer (valfritt)',
  'sale.pay.otherSolution': 'Annan betallösning',
  'sale.pay.settlementPrefix': 'Avräkning',
  'sale.pay.solutionAdded': 'Betallösning tillagd',
  'sale.pay.saveSolutionFailed': 'Kunde inte spara betallösningen.',
  'sale.pay.solutionExplainer': 'Vipps, PayPal, iZettle, Stripe och liknande bokförs på ett eget avräkningskonto för betallösningen, som stäms av när avräkningen har betalats ut till bankkontot.',
  'sale.pay.addCardAction': '+ Lägg till kreditkort ...',
  'sale.pay.addSolutionAction': '+ Lägg till betallösning ...',
  'sale.pay.partialLabel': 'Delbetalning {n}',
  'sale.pay.partialStatusRemaining': 'återstår',
  'sale.pay.partialStatusTooMuch': 'för mycket',
  'sale.pay.partialStatusMatches': 'stämmer',
  'sale.pay.partialSummary': 'Betalt {paid} av {expected} · {status}',
  'sale.pay.partialMismatch': 'Summan av delbetalningarna måste stämma med försäljningstotalen{feeSuffix} ({expected}).',
  'sale.list.noMembers': 'Listan har inga kunder att fakturera.',
  'sale.list.customerMissing': 'Kunden finns inte längre.',
  'sale.list.noneCreated': 'Inga fakturor skapades.',
  'sale.list.missingEmailNotice': '{count} fakturor har skapats för kunder utan e-post och måste skickas eller skrivas ut manuellt: {names}',
  'sale.list.notCreatedNotice': 'Inte slutfört för: {names}',
  'sale.list.createdNoEmail': 'Fakturan har skapats, men kunden saknar e-post. Skicka eller skriv ut den manuellt.',
  'sale.list.noneSent': 'Fakturorna har skapats, men ingen skickades via e-post. Skicka eller skriv ut manuellt: {names}',
  'sale.list.recipientsCount': '{count} mottagare',
  'sale.list.sentPartly': 'Skickad till {sent} mottagare. Inte skickad: {names}',
  'sale.list.sentAll': 'Skickad till {sent} mottagare.',
  'sale.pay.partialMismatchFeeSuffix': ' minus avgift',
  'sale.pay.feeTooHigh': 'Avgiften får inte vara större än försäljningen ({gross}).',
  'sale.pay.splitMismatchError': 'Delbetalningarna ({paid}) måste tillsammans stämma med försäljningstotalen minus avgift ({expected}).',
  'sale.product.backendUnavailable': 'Produktlagring är inte kopplad till backend.',
  'sale.product.added': 'Produkten "{name}" har lagts till',
  'sale.product.updated': 'Produkten "{name}" har uppdaterats',
  'sale.product.saveFailed': 'Kunde inte spara produkten.',
  'sale.create.backendUnavailable': 'Ny försäljning är inte kopplad till backend.',
});
